// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import {getAuth} from "@firebase/auth";
import {initializeFirestore} from "@firebase/firestore";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyALBJ1qePDGj79M0bFvrJys-TXYf-ZdVDo",
  authDomain: "edhrec-1563844611919.firebaseapp.com",
  databaseURL: "https://edhrec-1563844611919.firebaseio.com",
  projectId: "edhrec-1563844611919",
  storageBucket: "edhrec-1563844611919.appspot.com",
  messagingSenderId: "808648763959",
  appId: "1:808648763959:web:e1052db97990fd7b31edb2",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

export const firestore = initializeFirestore(app, {}, 'ch-games')
export const edhrecFirestore = initializeFirestore(app, {})

export const auth = getAuth(app)

export default app